import './SegmentedControl.scss';

export default function SegmentedControl({
    options,
    value,
    onChange,
    disabled = false,
    className = '',
}) {
    return (
        <div className={`ui-segmented ${className}`.trim()} role="group">
            {options.map(({ value: optionValue, label }) => {
                const isActive = value === optionValue;

                return (
                    <button
                        key={optionValue}
                        type="button"
                        className={`ui-segmented__option${isActive ? ' ui-segmented__option--active' : ''}`}
                        aria-pressed={isActive}
                        disabled={disabled}
                        onClick={() => onChange(optionValue)}
                    >
                        {label}
                    </button>
                );
            })}
        </div>
    );
}
